import { render, staticRenderFns } from "./ErrorNotification.vue?vue&type=template&id=33b41238&scoped=true&"
import script from "./ErrorNotification.vue?vue&type=script&lang=js&"
export * from "./ErrorNotification.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotification.vue?vue&type=style&index=0&id=33b41238&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b41238",
  null
  
)

export default component.exports